import {
  ProcurementCreationStatus,
  ProcurementPriority,
  ProcurementPurchaseOrderStatus,
  ProcurementRequestClientStatus,
  ProcurementStatus,
  WorkflowResolverType,
  WorkflowStepType,
} from 'types/procurement'

export const PROCUREMENT_CREATION_STATUS_LABELS = {
  [ProcurementCreationStatus.Draft]: 'Draft',
  [ProcurementCreationStatus.Submitted]: 'Submitted',
}

// Procurement Priority
export const PROCUREMENT_PRIORITY_COLORS = {
  [ProcurementPriority.Low]: '#8A8A8A',
  [ProcurementPriority.Normal]: '#FFFFFF',
  [ProcurementPriority.High]: '#F4D03F',
  [ProcurementPriority.Critical]: '#E74C3C',
}

export const PROCUREMENT_PRIORITY_LABELS = {
  [ProcurementPriority.Low]: 'Low',
  [ProcurementPriority.Critical]: 'Critical',
  [ProcurementPriority.Normal]: 'Normal',
  [ProcurementPriority.High]: 'High',
}

export const PROCUREMENT_PRIORITY_META = {
  [ProcurementPriority.Low]: {
    color: PROCUREMENT_PRIORITY_COLORS[ProcurementPriority.Low],
    label: PROCUREMENT_PRIORITY_LABELS[ProcurementPriority.Low],
  },
  [ProcurementPriority.Critical]: {
    color: PROCUREMENT_PRIORITY_COLORS[ProcurementPriority.Critical],
    label: PROCUREMENT_PRIORITY_LABELS[ProcurementPriority.Critical],
  },
  [ProcurementPriority.Normal]: {
    color: PROCUREMENT_PRIORITY_COLORS[ProcurementPriority.Normal],
    label: PROCUREMENT_PRIORITY_LABELS[ProcurementPriority.Normal],
  },
  [ProcurementPriority.High]: {
    color: PROCUREMENT_PRIORITY_COLORS[ProcurementPriority.High],
    label: PROCUREMENT_PRIORITY_LABELS[ProcurementPriority.High],
  },
}

// Procurement Status
export const PROCUREMENT_STATUS_COLORS = {
  [ProcurementStatus.WaitingForResolution]: '#F4D03F',
  [ProcurementStatus.Completed]: '#24D07B',
  [ProcurementStatus.Rejected]: '#E74C3C',
}

export const PROCUREMENT_STATUS_LABELS = {
  [ProcurementStatus.WaitingForResolution]: 'Waiting for resolution',
  [ProcurementStatus.Completed]: 'Completed',
  [ProcurementStatus.Rejected]: 'Rejected',
}

export const PROCUREMENT_STATUS_META = {
  [ProcurementStatus.WaitingForResolution]: {
    color: PROCUREMENT_STATUS_COLORS[ProcurementStatus.WaitingForResolution],
    label: PROCUREMENT_STATUS_LABELS[ProcurementStatus.WaitingForResolution],
  },
  [ProcurementStatus.Completed]: {
    color: PROCUREMENT_STATUS_COLORS[ProcurementStatus.Completed],
    label: PROCUREMENT_STATUS_LABELS[ProcurementStatus.Completed],
  },
  [ProcurementStatus.Rejected]: {
    color: PROCUREMENT_STATUS_COLORS[ProcurementStatus.Rejected],
    label: PROCUREMENT_STATUS_LABELS[ProcurementStatus.Rejected],
  },
}

// Procurement Request Status Display
export const PROCUREMENT_REQUEST_STATUS_DISPLAY_LABELS = {
  [ProcurementRequestClientStatus.Rejected]: 'Rejected',
  [ProcurementRequestClientStatus.Resolve]: 'Waiting for resolution',
  [ProcurementRequestClientStatus.ChangesRequested]: 'Completed',
  [ProcurementRequestClientStatus.CreatePO]: 'Create PO',
  [ProcurementRequestClientStatus.POCreated]: 'PO Created',
  [ProcurementRequestClientStatus.Draft]: 'Draft',
  [ProcurementRequestClientStatus.SubmitChanges]: 'Submit changes',
  [ProcurementRequestClientStatus.Approval]: 'Approval',
  [ProcurementRequestClientStatus.Sourcing]: 'Sourcing',
}

export const PROCUREMENT_REQUEST_STATUS_DISPLAY_COLORS = {
  [ProcurementRequestClientStatus.Rejected]: '#E74C3C',
  [ProcurementRequestClientStatus.Resolve]: '#F4D03F',
  [ProcurementRequestClientStatus.ChangesRequested]: '#24D07B',
  [ProcurementRequestClientStatus.CreatePO]: '#F4D03F',
  [ProcurementRequestClientStatus.POCreated]: '#FF9900',
  [ProcurementRequestClientStatus.Draft]: '#6A6A6A',
  [ProcurementRequestClientStatus.SubmitChanges]: '#FF9900',
  [ProcurementRequestClientStatus.Approval]: '#24D07B',
  [ProcurementRequestClientStatus.Sourcing]: '#AF52DE',
}



export const PROCUREMENT_REQUEST_CLIENT_STATUS_DISPLAY_META = {
  [ProcurementRequestClientStatus.Rejected]: {
    color: PROCUREMENT_REQUEST_STATUS_DISPLAY_COLORS[ProcurementRequestClientStatus.Rejected],
    label: PROCUREMENT_REQUEST_STATUS_DISPLAY_LABELS[ProcurementRequestClientStatus.Rejected],
  },
  [ProcurementRequestClientStatus.Resolve]: {
    color: PROCUREMENT_REQUEST_STATUS_DISPLAY_COLORS[ProcurementRequestClientStatus.Resolve],
    label: PROCUREMENT_REQUEST_STATUS_DISPLAY_LABELS[ProcurementRequestClientStatus.Resolve],
  },
  [ProcurementRequestClientStatus.ChangesRequested]: {
    color:
      PROCUREMENT_REQUEST_STATUS_DISPLAY_COLORS[ProcurementRequestClientStatus.ChangesRequested],
    label:
      PROCUREMENT_REQUEST_STATUS_DISPLAY_LABELS[ProcurementRequestClientStatus.ChangesRequested],
  },
  [ProcurementRequestClientStatus.CreatePO]: {
    color: PROCUREMENT_REQUEST_STATUS_DISPLAY_COLORS[ProcurementRequestClientStatus.CreatePO],
    label: PROCUREMENT_REQUEST_STATUS_DISPLAY_LABELS[ProcurementRequestClientStatus.CreatePO],
  },
  [ProcurementRequestClientStatus.POCreated]: {
    color: PROCUREMENT_REQUEST_STATUS_DISPLAY_COLORS[ProcurementRequestClientStatus.POCreated],
    label: PROCUREMENT_REQUEST_STATUS_DISPLAY_LABELS[ProcurementRequestClientStatus.POCreated],
  },
  [ProcurementRequestClientStatus.Draft]: {
    color: PROCUREMENT_REQUEST_STATUS_DISPLAY_COLORS[ProcurementRequestClientStatus.Draft],
    label: PROCUREMENT_REQUEST_STATUS_DISPLAY_LABELS[ProcurementRequestClientStatus.Draft],
  },
  [ProcurementRequestClientStatus.SubmitChanges]: {
    color: PROCUREMENT_REQUEST_STATUS_DISPLAY_COLORS[ProcurementRequestClientStatus.SubmitChanges],
    label: PROCUREMENT_REQUEST_STATUS_DISPLAY_LABELS[ProcurementRequestClientStatus.SubmitChanges],
  },
  [ProcurementRequestClientStatus.Approval]: {
    color: PROCUREMENT_REQUEST_STATUS_DISPLAY_COLORS[ProcurementRequestClientStatus.Approval],
    label: PROCUREMENT_REQUEST_STATUS_DISPLAY_LABELS[ProcurementRequestClientStatus.Approval],
  },
  [ProcurementRequestClientStatus.Sourcing]: {
    color: PROCUREMENT_REQUEST_STATUS_DISPLAY_COLORS[ProcurementRequestClientStatus.Sourcing],
    label: PROCUREMENT_REQUEST_STATUS_DISPLAY_LABELS[ProcurementRequestClientStatus.Sourcing],
  },
 
}

// Workflow Step Type
export const WORKFLOW_STEP_TYPE_LABELS = {
  [WorkflowStepType.Approval]: 'Approval',
  [WorkflowStepType.Sourcing]: 'Sourcing',
}

export const WORKFLOW_STEP_TYPE_META = {
  [WorkflowStepType.Approval]: {
    label: WORKFLOW_STEP_TYPE_LABELS[WorkflowStepType.Approval],
  },
  [WorkflowStepType.Sourcing]: {
    label: WORKFLOW_STEP_TYPE_LABELS[WorkflowStepType.Sourcing],
  },
}

// Workflow Resolver Type
export const WORKFLOW_RESOLVER_TYPE_LABELS = {
  [WorkflowResolverType.Roles]: 'Roles',
  [WorkflowResolverType.Users]: 'Users',
}

export const WORKFLOW_RESOLVER_TYPE_META = {
  [WorkflowResolverType.Roles]: {
    label: WORKFLOW_RESOLVER_TYPE_LABELS[WorkflowResolverType.Roles],
  },
  [WorkflowResolverType.Users]: {
    label: WORKFLOW_RESOLVER_TYPE_LABELS[WorkflowResolverType.Users],
  },
}

// Procurement Purchase Order Status



export const PROCUREMENT_PURCHASE_ORDER_STATUS_COLORS = {
  [ProcurementPurchaseOrderStatus.SendingEmailToSupplier]: '#F4D03F',
  [ProcurementPurchaseOrderStatus.PartiallyReceived]: '#24D07B',
  [ProcurementPurchaseOrderStatus.Received]: '#24D07B',
  [ProcurementPurchaseOrderStatus.EmailSentToSupplier]: '#E74C3C',
}

export const PROCUREMENT_PURCHASE_ORDER_STATUS_LABELS = {
  [ProcurementPurchaseOrderStatus.SendingEmailToSupplier]: 'Sending email to supplier',
  [ProcurementPurchaseOrderStatus.PartiallyReceived]: 'Partially received',
  [ProcurementPurchaseOrderStatus.Received]: 'Received',
  [ProcurementPurchaseOrderStatus.EmailSentToSupplier]: 'Email sent to supplier',
}

export const PROCUREMENT_PURCHASE_ORDER_STATUS_META = {
  [ProcurementPurchaseOrderStatus.SendingEmailToSupplier]: {
    color: PROCUREMENT_PURCHASE_ORDER_STATUS_COLORS[ProcurementPurchaseOrderStatus.SendingEmailToSupplier],
    label: PROCUREMENT_PURCHASE_ORDER_STATUS_LABELS[ProcurementPurchaseOrderStatus.SendingEmailToSupplier],
  },  [ProcurementPurchaseOrderStatus.PartiallyReceived]: {
    color: PROCUREMENT_PURCHASE_ORDER_STATUS_COLORS[ProcurementPurchaseOrderStatus.PartiallyReceived],
    label: PROCUREMENT_PURCHASE_ORDER_STATUS_LABELS[ProcurementPurchaseOrderStatus.PartiallyReceived],
  },
  [ProcurementPurchaseOrderStatus.Received]: {
    color: PROCUREMENT_PURCHASE_ORDER_STATUS_COLORS[ProcurementPurchaseOrderStatus.Received],
    label: PROCUREMENT_PURCHASE_ORDER_STATUS_LABELS[ProcurementPurchaseOrderStatus.Received],
  },
  [ProcurementPurchaseOrderStatus.EmailSentToSupplier]: {
    color: PROCUREMENT_PURCHASE_ORDER_STATUS_COLORS[ProcurementPurchaseOrderStatus.EmailSentToSupplier],
    label: PROCUREMENT_PURCHASE_ORDER_STATUS_LABELS[ProcurementPurchaseOrderStatus.EmailSentToSupplier],
  },
}